module.exports = __webpack_public_path__ + "static/illustration-hexowatch-03f1495c1de5597e5be7c22d28d664b3.png";